import MuiTable from './MuiTable.molecule';

export default MuiTable;
